export function getRoomPathname(roomId: string): string {
  return `/room/discovery/${roomId}`;
}

export function getRoomInvitePathname(
  roomId: string,
  playlistId: string | null
): string {
  const pathname = getRoomPathname(roomId);
  if (playlistId === null || playlistId === "") return pathname;
  return `${pathname}?playlist=${encodeURIComponent(playlistId)}`;
}
